import React from "react";

const ProcessAreaOne = () => {
  return (
    <section className="process-area-1 space position-relative">
      {/* Formas decorativas (ajusta las rutas si usas otras imágenes) */}


      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="title-area text-center">
              <span className="sub-title">Nuestro Proceso de Trabajo</span>
              <h2 className="sec-title">Las mejores soluciones en reparación</h2>
            </div>
          </div>
        </div>

        {/* Pasos del proceso */}
        <div className="row gy-30">
          {/* Paso 1 */}
          <div className="col-lg-4 process-card-wrap">
            <div className="process-card">
              <div className="process-card-icon">
                <img
                  src="/assets/img/icon/process-icon-1-1.svg"
                  alt="Diagnóstico"
                />
              </div>
              <h4 className="process-card-title">Diagnóstico / Peritación 🔍</h4>
              <p className="process-card-text">
                Nuestro equipo evalúa los daños de tu vehículo para determinar la
                mejor solución. Realizamos un informe preciso y acordamos
                contigo los pasos a seguir.
              </p>
            </div>
          </div>

          {/* Paso 2 */}
          <div className="col-lg-4 process-card-wrap">
            <div className="process-card process-card-center">
              <div className="process-card-icon">
                <img
                  src="/assets/img/icon/process-icon-1-2.svg"
                  alt="Reparación"
                />
              </div>
              <h4 className="process-card-title">Reparación del Automóvil 🛠️</h4>
              <p className="process-card-text">
                Utilizamos materiales de alta calidad y técnicas especializadas
                para llevar a cabo la reparación y la pintura de la carrocería,
                garantizando un acabado impecable.
              </p>
            </div>
          </div>

          {/* Paso 3 */}
          <div className="col-lg-4 process-card-wrap">
            <div className="process-card">
              <div className="process-card-icon">
                <img
                  src="/assets/img/icon/process-icon-1-3.svg"
                  alt="Verificación"
                />
              </div>
              <h4 className="process-card-title">Verificación Final ✅</h4>
              <p className="process-card-text">
                Hacemos una revisión minuciosa para asegurarnos de que todo
                cumple con nuestros altos estándares de calidad antes de
                entregarte tu coche.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProcessAreaOne;
